import React, { PropTypes, Component } from 'react'
import Link from 'react-router/lib/Link'
import Print from 'react-icons/lib/md/print'

import FormModal from 'components/FormModal'
import FormContainerSubject from './form-container-subject'
import ListSubjects from './list-subjects'

class ListSubjectsContainer extends Component {

  constructor(props) {
    super(props)

    this.state = {
      openForm: false,
      item: null, // the current subject
    }
  }

  _openForm = () => {
    this.setState({
      openForm: true,
      item: null,
    })
  }

  _onSelectItem = (item) => {
    this.setState({
      item,
      openForm: true,
    })
  }

  _renderList() {
    const { subjectList } = this.props

    if (!subjectList) {
      return null
    }

    return (
      <ListSubjects
        subjectList={subjectList}
        onSelectItem={this._onSelectItem}
      />
    )
  }

  _renderSubjectForm() {
    const { openForm, item } = this.state
    const { subjectOptions, id } = this.props

    if (!openForm || !subjectOptions) {
      return null
    }

    return (
      <FormModal modalClass="modal-lg" handleClose={() => this.setState({ openForm: false })}>
        <FormContainerSubject
          item={item}
          id={id}
          subjectOptions={subjectOptions}
          handleClose={() => this.setState({ openForm: false })}
        />
      </FormModal>
    )
  }

  render() {
    const { id } = this.props

    return (
      <div>
        <div className="row m-b-20">
          <div className="col-sm-6">
            <button type="button" onClick={this._openForm} className="btn btn-info">Add Curriculum Subject</button>
          </div>
          <div className="col-sm-6 text-right">
            <Link to={`/print/curriculums/${id}`} target="_blank" className="btn btn-icon"><Print /></Link>
          </div>
        </div>
        {this._renderList()}
        {this._renderSubjectForm()}
      </div>
    )
  }
}

ListSubjectsContainer.propTypes = {
  id: PropTypes.number,
  subjectList: PropTypes.object,
  subjectOptions: PropTypes.array,
}

export default ListSubjectsContainer



// WEBPACK FOOTER //
// ./src/containers/Manage/Curriculums/list-subjects-container.js